// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","about-us-tab__container":"about-us-tab__container","google-static-map":"google-static-map","about-us-tab__header":"about-us-tab__header","about-us-tab__description-image-container":"about-us-tab__description-image-container","about-us-tab__image":"about-us-tab__image","fhpic":"fhpic","logo":"logo","about-us-tab__description":"about-us-tab__description","details":"details"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Profile/components/Tabs/AboutUs/css/AboutUs.styl
// module id = 1472
// module chunks = 0